import { diffDates } from '@fullcalendar/core';
import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    id_proceso: '',
    vehiculo: {
        marca: "",
        linea: "",
        version: "",
        modelo: "",
        precio_base: 0,
        precio_venta: 0,
        placa: "",
        transito: {
            transito_name: ""
        },
        estado: ""
    },
    vendedor: {
        datos_personales: [],
        resumen: {
            facturacion_total: 0,
            comision: 0,
            vr_iva: 0,
            impuesto_4_x_mil: 0,
            gastos_traspaso: 0,
            recaudo_total: 0,
            pagar_total: 0,
            saldo_total: 0,
            soportes: []
        }
    },
    comprador: {
        datos_personales: [],
        resumen: {
            gastos_traspaso: 0,
            recaudo_total: 0,
            pagar_total: 0,
            soportes: {}
        }
    },
    facturacion: {
        facturacion_total: 0,
        facturacionLocal: {
            comision: 0,
            sobreprecio: 0,
            credito: 0,
            poliza: 0,
            tramite: 0,
            alistamiento: 0,
            ganancia_fondo: 0,
            administracion: 0
        }
    },
    documentos: {
        input_slug: '',
        tipo: ''
    }
};
const mutations = {
    updateField,
    updateFacturacion: (state, payload) =>{
        state.id_proceso = payload._id;
        state.vehiculo = {...state.vehiculo, ...payload.vehiculo};
        state.vendedor.datos_personales = {...state.vendedor.datos_personales, ...payload.vendedor};
        state.comprador.datos_personales = {...state.comprador.datos_personales, ...payload.comprador};
        state.vehiculo.estado = payload.estado_principal.slug;
        state.facturacion.facturacion_total = payload.facturacion_total;
        state.facturacion.facturacionLocal = {...state.facturacion.facturacionLocal, ...payload.facturacion};
    },
    updateRecaudo: (state, payload) => {
        state.id_proceso = payload._id
        state.vehiculo = {
            ...state.vehiculo,
            ...payload.vehiculo,
            estado: payload.estado_principal.slug
        };
        var soportes_recaudo = payload.soportes_data.recaudo.soportes_comprador;
        var soportes_pago = payload.soportes_data.pago.soportes_comprador;
        var soportes = soportes_recaudo.concat(soportes_pago);
        var newItems = payload.proceso.tramite.gastos_traspaso.new_items;
        var newItemsComprador = 0;
        newItems.forEach(element => {
            newItemsComprador += element.cp_value;
        });
        state.comprador = {
            ...state.comprador,
            ...payload.comprador,
            resumen: {
                gastos_traspaso: payload.gastos_comprador + newItemsComprador,
                soportes: soportes,
                recaudo_total: payload.soportes_data.recaudo.comprador,
                pagar_total: payload.soportes_data.pago.comprador,
                soportes_total: payload.soportes_data.recaudo.comprador - payload.soportes_data.pago.comprador
            }
        };
    },
    updatePagar: (state, payload) =>{
        state.id_proceso = payload._id
        state.vehiculo = {
            ...state.vehiculo,
            ...payload.vehiculo,
            estado: payload.estado_principal.slug
        };
        var soportes_recaudo = payload.soportes_data.recaudo.soportes_vendedor;
        var soportes_pago = payload.soportes_data.pago.soportes_vendedor;
        var soportes = soportes_recaudo.concat(soportes_pago);
        var newItems = payload.proceso.tramite.gastos_traspaso.new_items;
        var newItemsVendedor = 0;
        newItems.forEach(element => {
            newItemsVendedor += element.vd_value;
        });
        state.vendedor = {
            ...state.vendedor,
            ...payload.vendedor,
            resumen: {
                facturacion_total: payload.facturacion_total,
                comision: payload.facturacion.comision,
                vr_iva: payload.facturacion.valor_iva,
                impuesto_4_x_mil: payload.facturacion.impuesto_4_x_mil,
                gastos_traspaso: payload.gastos_vendedor + newItemsVendedor,
                recaudo_total: payload.soportes_data.recaudo.vendedor,
                pagar_total: payload.soportes_data.pago.vendedor,
                soportes_total: payload.soportes_data.pago.vendedor - payload.soportes_data.recaudo.vendedor,
                soportes: soportes
            }
        };
    },
    updateInputSlug: (state, payload) => {
        state.documentos = {...state.documentos, ...payload};
    }
};

const getters = {
    getField
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
